module.exports = __webpack_public_path__ + "img/11.2c2b6bb4.jpg";